import { createTheme, responsiveFontSizes } from '@mui/material/styles'

import { baseTheme } from '../../theme/baseTheme'
import { lightTheme } from '../../theme/lightTheme'

export const themeUpdater = (theme) => {
  let updatedTheme = createTheme(
    baseTheme({ typography: theme.typography, app: mapApp(theme) }),
    lightTheme({ palette: mapPalette(theme) })
  )
  updatedTheme = responsiveFontSizes(updatedTheme)
  return updatedTheme
}

function mapPalette(data) {
  const palette = data?.palette || {}
  return {
    primary: palette.primary,
    secondary: palette.secondary,
    error: palette.error,
    info: palette.info,
    action: palette.action,
    text: palette.text,
    divider: palette.other.divider,
    background: {
      backdrop: palette.other.backdropOverlay,
    },
  }
}

function mapApp(data) {
  return {
    default: data?.app?.default,
    name: data?.app?.name,
    logo: data?.app?.logo,
  }
}
